module.exports = __webpack_public_path__ + "img/Anu Yammanuru.0568621f.jpg";